export default __webpack_public_path__ + "assets/images/aistudio/views/c5b5fd655ac98208b1981916dcd19b85.png";